import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { FaTimes } from 'react-icons/fa';

const DeactivateFamilyMemberModal = ({ mounted, show, member, onClose, onSubmit }) => {
  const [reasonCode, setReasonCode] = useState('');
  const [confirm, setConfirm] = useState('');

  const reasonOptions = [
    'Relationship Change',
    'User Request',
    'Fraud Suspected',
    'Other'
  ];

  useEffect(() => {
    if (show) {
      setReasonCode('');
      setConfirm('');
    }
  }, [show]);

  if (!mounted || !show || !member) return null;

  const memberId = member.member_id || member.id || '';

  const handleSubmit = () => {
    if (!reasonCode.trim()) {
      return;
    }
    onSubmit(memberId, reasonCode);
  };

  return createPortal(
    <div className="fixed top-0 left-0 w-screen h-screen bg-black/80 z-[9999] m-0 p-0 flex items-center justify-center">
      <div className="bg-white rounded-lg border border-gray-200 w-full max-w-xl shadow-xl m-6">
        <div className="px-6 py-4 border-b flex items-center justify-between">
          <div className="font-semibold">Deactivate Family Member</div>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            <FaTimes />
          </button>
        </div>
        <div className="p-6 space-y-4">
          <div className="text-sm text-gray-600 bg-yellow-50 border border-yellow-200 rounded-md p-3">
            This action will soft-deactivate {member?.name || 'this member'} from the subscription. The member will remain in history but will be marked as inactive.
          </div>
          <div>
            <label className="block text-sm text-gray-600 mb-1">Reason Code</label>
            <select
              className="w-full border rounded-md px-3 py-2"
              value={reasonCode}
              onChange={(e) => setReasonCode(e.target.value)}
            >
              <option value="">Select reason for deactivation</option>
              {reasonOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm text-gray-600 mb-1">Type DEACTIVATE to confirm</label>
            <input
              type="text"
              className="w-full border rounded-md px-3 py-2"
              placeholder="Type DEACTIVATE"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
            />
          </div>
          <div className="text-xs text-gray-500 border border-gray-200 rounded-md p-3">
            <div className="font-medium mb-2">This action will:</div>
            <ul className="list-disc list-inside space-y-1">
              <li>Mark the member as inactive</li>
              <li>Preserve all historical data</li>
              <li>Prevent future transactions under this member</li>
            </ul>
          </div>
          <div className="flex justify-end space-x-2 pt-2">
            <button
              onClick={onClose}
              className="px-3 py-2 border border-gray-300 rounded-md text-sm text-gray-700 hover:text-white hover:bg-blue-600 hover:border-blue-600 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              disabled={!reasonCode || !confirm.startsWith('DEACTIVATE')}
              className={`px-3 py-2 rounded-md text-sm transition-colors ${
                !reasonCode || !confirm.startsWith('DEACTIVATE')
                  ? 'bg-red-200 text-white cursor-not-allowed'
                  : 'bg-red-500 text-white hover:bg-red-600'
              }`}
            >
              Deactivate Member
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default DeactivateFamilyMemberModal;

